import React from 'react'
import { ChatBreakoutSquare, DollarIcon, LikeIcon, MessageChatCircle, MessageSmileCircle, Zap } from '../../icons'

const BookingCard = ({ icon, title, detail }) => {
    return (
        <div className="flex items-start max-sm:flex-col gap-[20px] w-full max-sm:items-center">
            <div className="flex items-center justify-center p-[8px] rounded-full bg-[#A4D6B4] w-fit">
                <div className="flex items-center justify-center p-[8px]  rounded-full bg-[#1C9943]">
                    {icon}
                </div>
            </div>
            <div className="flex flex-col gap-[8px]">
                <span className='text-[#101828] text-[20px] font-bold max-sm:text-center'>
                    {title}
                </span>
                <p className='text-[16px] text-[#475467] max-sm:text-center'>
                    {detail}
                </p>
            </div>
        </div>
    )
}

const BookingSection = () => {
    return (
        <div className='py-[96px] flex flex-col gap-[64px] px-[5.8vw] w-ful overflow-hidden max-w-[1980px] w-full'>
            <div className="flex flex-col gap-[20px] max-w-[768px] max-lg:flex-col max-lg:text-center">
                <div className="flex flex-col gap-[12px]">
                    <span className='text-[#1C9943] font-bold'>
                        How to be Healthy
                    </span>
                    <h2 className='text-[36px] font-bold text-[#101828]'>
                        The Truth is if You Think Your Body is Full of Fat.
                    </h2>
                </div>
                <p className='text-[20px] text-[#475467]'>
                    Powerful, self-serve product and growth analytics to help you convert, engage, and retain more users. Trusted by over 4,000 startups.
                </p>
            </div>
            <div className="flex items-center justify-between gap-[64px] max-lg:flex-col">
                <div className="grid grid-cols-1 gap-[32px] w-[40%]">
                    <BookingCard
                        icon={<MessageChatCircle iconColor={'#FFF'} />}
                        title={'Unlimited cards'}
                        detail={'Give your team the autonomy they need with access to as many cards as they need. Authorise purchases with a click. Simple.'}
                    />
                    <BookingCard
                        icon={<DollarIcon iconColor={'#FFF'} />}
                        title={'Easy expense policies'}
                        detail={'Every card comes with configurable spending limits, purchase restrictions, and cancellations for each employee and team.'}
                    />
                    <BookingCard
                        icon={<ChatBreakoutSquare iconColor={'#FFF'} />}
                        title={'Advanced analytics'}
                        detail={'An all-in-one platform that helps you balance everything your team need to be happy and your finances in order.'}
                    />
                </div>
                <div className="w-full p-[24px] flex flex-col gap-[28px] h-full">
                    <div className="flex items-start gap-[16px]">
                        <img src="/images/doctor.png" className='w-[140px] ' alt="" />
                        <div className="flex flex-col gap-[16px] w-full">
                            <h4 className='text-[20px] text-[#101828] font-[600]'>
                                Dr. Monty
                            </h4>
                            <div className="flex flex-col gap-[4px]">
                                <span className='text-[#787887] text-[14px]'>
                                    Dentist
                                </span>
                                <span className='text-[#787887] text-[14px]'>
                                    10 years experience overall
                                </span>
                            </div>
                            <div className="flex flex-col gap-[4px]">
                                <h4 className='text-[20px] text-[#101828] font-[600]'>
                                    UCL,London
                                </h4>
                                <span className='text-[#787887] text-[14px]'>
                                    Fittness center Manchester+ 1
                                </span>
                            </div>
                            <span className='flex items-center gap-[4px] text-[#787887] text-[14px]'>
                                <span className='text-[#1C9943] font-[700]'>Free</span>
                                <span>$230</span>
                                Consultation fee at clinic
                            </span>
                            <hr className='border-dashed border-[#E8E8F0] w-full' />
                            <div className="flex items-center gap-[12px]">
                                <div className="flex items-center gap-[8px] bg-[#1C9943] p-[8px] text-[#FFF] rounded-[4px]">
                                    <LikeIcon iconColor='#FFF' className={'w-[20px] h-[20px]'} />
                                    99%
                                </div>
                                <span className='text-[#414146] font-[700]'>
                                    Patient Stories
                                </span>
                            </div>
                        </div>
                        <div className="w-full h-full flex gap-[12px] items-center justify-end flex-col">
                            <span className='text-[#1C9982]'>
                                Available Today
                            </span>
                            <button className='cursor-pointer text-[#FFF] bg-[#1C9943] py-[12px] px-[24px] rounded-[8px] transition-all hover:scale-90'>
                                Book FREE Consultance
                            </button>
                        </div>
                    </div>
                    <hr />
                    <div className="flex flex-col gap-[24px]">
                        <div className="flex items-center gap-[40px]">
                            <span className='text-[#414146] text-[14px] w-[100px]'>
                                Morning
                            </span>
                            <button className='text-[#1C9982] border-[1px] border-[#1C9982] py-[8px] px-[12px] rounded-[8px] w-[100px] transition-all hover:bg-[#1C9982] hover:text-[#FFF]'>
                                11:30 AM
                            </button>
                        </div>
                        <hr />
                        <div className="flex items-center gap-[40px]">
                            <span className='text-[#414146] text-[14px] w-[100px]'>
                                Afternoon
                            </span>
                            <button className='text-[#1C9982] border-[1px] border-[#1C9982] py-[8px] px-[12px] rounded-[8px] w-[100px] transition-all hover:bg-[#1C9982] hover:text-[#FFF]'>
                                12:00 PM
                            </button>
                            <button className='text-[#1C9982] border-[1px] border-[#1C9982] py-[8px] px-[12px] rounded-[8px] w-[100px] transition-all hover:bg-[#1C9982] hover:text-[#FFF]'>
                                12:30 PM
                            </button>
                            <button className='text-[#1C9982] border-[1px] border-[#1C9982] py-[8px] px-[12px] rounded-[8px] w-[100px] transition-all hover:bg-[#1C9982] hover:text-[#FFF]'>
                                1:30 PM
                            </button>
                            <button className='text-[#1C9982] border-[1px] border-[#1C9982] py-[8px] px-[12px] rounded-[8px] w-[100px] transition-all hover:bg-[#1C9982] hover:text-[#FFF]'>
                                2:00 PM
                            </button>
                            <button className='text-[#1C9982] border-[1px] border-[#1C9982] py-[8px] px-[12px] rounded-[8px] w-[100px] transition-all hover:bg-[#1C9982] hover:text-[#FFF]'>
                                2:30 PM
                            </button>
                        </div>
                        <hr />
                        <div className="flex items-center gap-[40px]">
                            <span className='text-[#414146] text-[14px] w-[100px]'>
                                Evening
                            </span>
                            <button className='text-[#1C9982] border-[1px] border-[#1C9982] py-[8px] px-[12px] rounded-[8px] w-[100px] transition-all hover:bg-[#1C9982] hover:text-[#FFF]'>
                                6:00 PM
                            </button>
                            <button className='text-[#1C9982] border-[1px] border-[#1C9982] py-[8px] px-[12px] rounded-[8px] w-[100px] transition-all hover:bg-[#1C9982] hover:text-[#FFF]'>
                                6:30 PM
                            </button>
                            <button className='text-[#1C9982] border-[1px] border-[#1C9982] py-[8px] px-[12px] rounded-[8px] w-[100px] transition-all hover:bg-[#1C9982] hover:text-[#FFF]'>
                                7:00 PM
                            </button>
                            <button className='text-[#1C9982] border-[1px] border-[#1C9982] py-[8px] px-[12px] rounded-[8px] w-[100px] transition-all hover:bg-[#1C9982] hover:text-[#FFF]'>
                                7:30 PM
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default BookingSection;